"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Switcher = _interopRequireDefault(require("../../preact-components/control/Switcher"));

var CONTENT_TYPES = ['articles', 'questions', 'discussions', 'answers'];

var Visibility = function Visibility(props) {
  var visibility = props.visibility;
  return (0, _preact.h)("div", {
    className: "row"
  }, (0, _preact.h)("label", null, "Visibility"), (0, _preact.h)("p", null, "Specify in which content types you want to show this element"), CONTENT_TYPES.map(function (c) {
    var contentType = c;
    var v = visibility === null || visibility === void 0 ? void 0 : visibility[c];
    return (0, _preact.h)("div", {
      key: c,
      className: "col-md-6 content-helpfulness_visibility-checks"
    }, (0, _preact.h)(_Switcher.default, {
      on: v,
      onChange: function onChange() {
        return props.onChange((0, _defineProperty2.default)({}, contentType, !v));
      }
    }), (0, _preact.h)("label", {
      className: "switch-label"
    }, contentType === 'discussions' ? 'conversations' : contentType));
  }));
};

var _default = Visibility;
exports.default = _default;